import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import Permissions from '@/modules/profile/Permissions'
import { Stack } from 'expo-router'

export default function PermissionsPage() {
  const headerLeftItems = useWebBackButton('/profile')

  return (
    <>
      <Stack.Screen options={{ ...buildScreenHeaderItems({ left: headerLeftItems }) }} />
      <Permissions />
    </>
  )
}
